/**
 * Treats reward result as empty when it is undefined, null, empty string, 0, or '0'.
 * Use in render to keep UI logic clean (e.g. show "—" or waiting state).
 */
export function isEmptyRewardResult(
  value: number | string | undefined | null,
): boolean {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    value === 0 ||
    value === '0'
  )
}
